module.exports = __webpack_public_path__ + "static/img/xfxt.2e6472d7.png";